import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/manga";

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroSlides.map((s, idx) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            idx === current ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={s.cover}
            alt={s.title}
            className="w-full h-full object-cover"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
          <div className="max-w-2xl">
            <span className="inline-block bg-accent-500 text-background-50 text-xs font-semibold px-3 py-1 rounded-full mb-4">
              {slide.category === "hanman" ? "🔥 韩漫推荐" : slide.category === "riman" ? "⚔️ 日漫系列" : "⭐ 国漫精选"}
            </span>
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 font-heading">
              {slide.title}
            </h1>
            <p className="text-sm md:text-base text-white/80 mb-2">{slide.subtitle}</p>
            <p className="text-sm text-white/60 mb-6">{slide.description}</p>
            <Link
              to={`/article/${slide.id}`}
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              立即阅读 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => goTo(idx)}
            className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
              idx === current
                ? "bg-white w-6"
                : "bg-white/40 hover:bg-white/60"
            }`}
            aria-label={`Slide ${idx + 1}`}
          />
        ))}
      </div>
    </section>
  );
}